// src/pages/NotFound.tsx
import React from "react";
import { Link } from "react-router-dom";
import { logout } from "../redux/features/authSlice";

const NotFound = () => {
  return (
    <div className="h-screen flex flex-col items-center justify-center bg-gray-100 text-gray-800 px-4">
      <h1 className="text-6xl font-bold mb-4">404</h1>
      <p className="text-2xl mb-2">Oops! Page not found.</p>
      <p className="mb-6 text-center max-w-md">
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </p>
      <Link
        to="/"
        className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
        onClick={() => logout()}
      >
        Go to Home
      </Link>
    </div>
  );
};

export default NotFound;
